import React, { useEffect, useRef, useState } from 'react';
import { IonContent, IonPage, useIonAlert } from '@ionic/react';
import EbioroLoadingLogo from '../../components/EbioroLoading/EbioroLoadingLogo';
import { useTranslation } from 'react-i18next';
import { dispatch } from '../../services/redux/store';
import { ebioroApi } from '../../services/api/ebioro/ebioro';
import * as Sentry from '@sentry/react';
import PaymentSuccess from '../payment-success/PaymentSuccess';
import { closeModal } from '../../services/redux/slices/opened_navigation_modal/opened_root_modal';

interface MyProps {
  transactionId: string;
  messageText?:string;
  successMessage?:string;
}

const PaymentProcessing: React.FC<MyProps> = ({ transactionId,successMessage,messageText }) => {

  const { t } = useTranslation();
  const [present] = useIonAlert();
  const nav = document.querySelector("ion-nav");
  const isComponentMounted = useRef(true);
  const [mainText,setMainText] = useState(messageText?messageText:t('send.page.WAIT-MESSAGE-MAIN'))

  const presentErrorAlert = (message: string) => {
    present({
      header: 'Error',
      message: `${message}`,
      buttons: [{
        text: t('close'), role: 'cancel', handler: () => {
          close();
        }
      }],
    });
  };

  const close = () => {

    dispatch(closeModal());

}

  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  const fetchTransactionStatus = async (id: string) => {
    return dispatch(ebioroApi.endpoints.getTransaction.initiate(id, { forceRefetch: true })).unwrap();
  };

  const getTransactionStatus = async (id: string) => {

    if (!isComponentMounted.current) return;

    try {
      
      let result = await fetchTransactionStatus(id);

      while (!['processing', 'completed', 'error'].includes(result.status)) {
        if (result.status==='surge_pricing'){
          setMainText(t('send.page.WAIT-SURGE-PRICING'))
        }
        await sleep(4000);
        result = await fetchTransactionStatus(id);
      }

      if (result.status === 'error') {
        throw new Error(result.status_message === 'submission_error' ? 'submission_error' : 'transaction_error');
      }

      goToPaymentSuccess();

    } catch (error) {

      Sentry.captureException(error);

      const errorMessage = error instanceof Error ? error.message : '';

      if (errorMessage === 'submission_error') {
        presentErrorAlert(t('transaction.submission.ERROR'))
      } else {
        presentErrorAlert(t('application.uncaught.ERROR'));
      }
    }
  };

  const goToPaymentSuccess = async () => {

    nav?.push(() =>
      <PaymentSuccess
        successMessage = {successMessage?successMessage:t('paymentsuccess.page.MESSAGE') as string}
      />)
  }

  useEffect(() => {
    getTransactionStatus(transactionId);
    return () => {
      isComponentMounted.current = false;
    };
  }, [transactionId]);

  return (
    <IonPage>
      <IonContent fullscreen scrollY={false} className="sendPageWaitModal_content_background">
        <div className="ion-text-center">
          <div className="sendPageWaitModal_logo-on-center">
            <EbioroLoadingLogo
              icon_color="white"
              mainText={mainText as string}
              mainTextColor="white"
              subText={t('send.page.WAIT-MESSAGE-SUB') as string}
              subTextColor="white"
            />
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default React.memo(PaymentProcessing);
